<template>
  <div>
    <ul class="pagination justify-content-center ap-pagination" v-if="total===0">No data !</ul>
    <ul class="pagination justify-content-center ap-pagination" v-if="total>0">
      <li class="page-item" :class="{'disabled': pageIndex == 1}">
        <a class="page-link" @click="pageTo(pageIndex-1)">«</a>
      </li>
      <template v-if="pageCount >= 1">
        <template v-if="pageCount <= number">
          <li class="page-item" :class="{'active': i == pageIndex}" v-for="i in pageCount" :key="i">
            <a class="page-link" @click="pageTo(i)">{{i}}</a>
          </li>
        </template>
        <template v-else>
          <template v-if="pageIndex < number - 2">
            <li class="page-item" :class="{'active': i == pageIndex}" v-for="i in (number - 2)" :key="i">
              <a class="page-link" @click="pageTo(i)">{{i}}</a>
            </li>
            <li class="page-item disabled">
              <a class="page-link" tabindex="-1">...</a>
            </li>
            <li class="page-item" :class="{'active': pageCount == pageIndex}">
              <a class="page-link" tabindex="-1" @click="pageTo(pageCount)">{{pageCount}}</a>
            </li>
          </template>
          <template v-else-if="pageIndex >= number - 2 && pageIndex <= pageCount - 4">
            <li class="page-item">
              <a class="page-link" @click="pageTo(1)">1</a>
            </li>
            <li class="page-item disabled">
              <a class="page-link" tabindex="-1">...</a>
            </li>
            <li class="page-item">
              <a class="page-link" @click="pageTo(pageIndex - 1)">{{pageIndex - 1}}</a>
            </li>
            <li class="page-item active">
              <a class="page-link" @click="pageTo(pageIndex)">{{pageIndex}}</a>
            </li>
            <li class="page-item">
              <a class="page-link" @click="pageTo(pageIndex + 1)">{{pageIndex + 1}}</a>
            </li>
            <li class="page-item disabled">
              <a class="page-link" tabindex="-1">...</a>
            </li>
            <li class="page-item">
              <a class="page-link" tabindex="-1" @click="pageTo(pageCount)">{{pageCount}}</a>
            </li>
          </template>
          <template v-else>
            <li class="page-item">
              <a class="page-link" @click="pageTo(1)">1</a>
            </li>
            <li class="page-item disabled">
              <a class="page-link" tabindex="-1">...</a>
            </li>
            <li class="page-item" :class="{'active': i + (pageCount - 5) == pageIndex}" v-for="i in 5" :key="i">
              <a class="page-link" tabindex="-1" @click="pageTo(i + (pageCount - 5))">{{i + (pageCount - 5)}}</a>
            </li>
          </template>
        </template>
      </template>
      <li class="page-item" :class="{'disabled': pageIndex == pageCount || pageCount <= 1}">
        <a class="page-link" @click="pageTo(pageIndex+1)">»</a>
      </li>
      <template v-if="!onlyNumber&&this.pageCount>this.number">
        <li style="margin-left:30px">
          <strong>共{{pageCount}}页 转到第</strong>
          <input type="text" class="form-control form-control-sm" v-model="pageNumber" @keyup.enter="goToPage" />
          <strong>页</strong>
        </li>
        <li>
          <button class="btn btn-secondary btn-sm" @click="goToPage">GO</button>
        </li>
      </template>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    total: {
      default: 0
    },
    index: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 0
    },
    number: {
      type: Number,
      default: 7
    },
    onlyNumber: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (this.number < 7) {
      this.number = 7;
    }
    this.pageCount = Math.ceil(this.total / this.pageSize);
  },
  data() {
    return {
      pageCount: 0,
      pageIndex: 1,
      pageNumber: "",
      pageSize: this.limit || this.$limit
    };
  },
  watch: {
    total(v) {
      this.pageCount = Math.ceil(v / this.pageSize);
    },
    index(v) {
      this.pageIndex = v;
    }
  },
  computed: {
    offset() {
      return (this.pageIndex - 1) * this.pageSize;
    }
  },
  methods: {
    pageTo(idx) {
      if (idx == 1) {
        this.pageIndex = idx;
        this.$emit("page-to", {
          offset: this.offset,
          limit: this.pageSize
        });
        return;
      }
      if (idx >= 1 && idx <= this.pageCount) {
        this.pageIndex = idx;
        this.$emit("page-to", {
          offset: this.offset,
          limit: this.pageSize
        });
      }
    },
    refresh() {
      this.$emit("page-to", {
        offset: this.offset,
        limit: this.pageSize
      });
    },
    goToPage() {
      if (this.pageNumber) {
        let n = parseInt(this.pageNumber, 10);
        if (!isNaN(n) && n <= this.pageCount && n >= 0) {
          this.pageIndex = n;
          this.$emit("page-to", {
            offset: this.offset,
            limit: this.pageSize
          });
        }
      }
    },
    reset() {
      this.pageIndex = 1;
      this.$emit("page-to", {
        offset: 0,
        limit: this.pageSize
      });
    }
  }
};
</script>

<style lang="less">
.ap-pagination {
  li {
    display: flex;
    align-items: center;
    strong,
    input {
      display: inline-block;
      vertical-align: middle;
    }
    input {
      margin: 0 10px 0;
      width: 48px;
      text-align: center;
    }
    .btn {
      margin-left: 10px;
    }
  }
}
</style>
